"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatorSigner = void 0;
const errors_1 = require("./errors");
const validatorKeys_1 = require("./validatorKeys");
/**
 * Validator signer (BLS signer)
 */
class ValidatorSigner {
    /**
     * Signs a message.
     */
    signUsingPem(pemText, pemIndex = 0, signable) {
        return __awaiter(this, void 0, void 0, function* () {
            yield validatorKeys_1.BLS.initIfNecessary();
            try {
                let secretKey = validatorKeys_1.ValidatorSecretKey.fromPem(pemText, pemIndex);
                secretKey.sign(signable);
            }
            catch (err) {
                throw new errors_1.ErrSignerCannotSign(err);
            }
        });
    }
}
exports.ValidatorSigner = ValidatorSigner;
//# sourceMappingURL=validatorSigner.js.map